const css = `.index-module__icon___ZSB-3 {
  color: #FF9500;
}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
export default {
  "icon": "index-module__icon___ZSB-3"
};